import React, {useContext} from "react";
import './Video.css';
import Title from "../../ui/title/Title";
import List from "../../ui/list-item/List";
import Button from "../../ui/button/Button";
import Video1 from './assets/image-1.png';
import Video2 from './assets/image-2.png';
import Video3 from './assets/image-3.png';
import Video4 from './assets/image-4.png';
import Video5 from './assets/image-5.png';
import Video6 from './assets/image-6.png';
import WifiImg from './assets/wifi.svg'
import WifimanImg from './assets/wifi-man.svg'
import PhoneImg from './assets/phone.svg'
import MoonImg from './assets/moon.svg'
import MicroImg from './assets/micro.svg'
import FolderImg from './assets/folder.svg'
import { FormContext } from "../../app/App";

const cardsData = [
    {class: 'image-item', wraper: 'card-wraper', img: Video1, imageClass: 'list-image', title: 'В офисе', titleClass: 'card-title'},
    {class: 'image-item', wraper: 'card-wraper', img: Video2, imageClass: 'list-image', title: 'В магазине', titleClass: 'card-title'},
    {class: 'image-item', wraper: 'card-wraper', img: Video3, imageClass: 'list-image', title: 'На стройке', titleClass: 'card-title'},
    {class: 'image-item', wraper: 'card-wraper', img: Video4, imageClass: 'list-image', title: 'В кафе/ресторане', titleClass: 'card-title'},
    {class: 'image-item', wraper: 'card-wraper', img: Video5, imageClass: 'list-image', title: 'На складе', titleClass: 'card-title'},
    {class: 'image-item', wraper: 'card-wraper', img: Video6, imageClass: 'list-image', title: 'На улице', titleClass: 'card-title'},
]

const benefitsData = [
    {class: 'image-item', wraper: 'benefit-wraper', img: WifiImg, imageClass: 'wifi', title: 'Подключение по WI-FI', titleClass: 'image-title'},
    {class: 'image-item', wraper: 'benefit-wraper', img: WifimanImg, imageClass: 'wifiman', title: 'Датчик движения', titleClass: 'image-title'},
    {class: 'image-item', wraper: 'benefit-wraper', img: PhoneImg, imageClass: 'phone', title: 'Доступ через телефон', titleClass: 'image-title'},
    {class: 'image-item', wraper: 'benefit-wraper', img: MoonImg, imageClass: 'moon', title: 'Съемка в темноте', titleClass: 'image-title'},
    {class: 'image-item', wraper: 'benefit-wraper', img: MicroImg, imageClass: 'micro', title: 'Запись звука', titleClass: 'image-title'},
    {class: 'image-item', wraper: 'benefit-wraper', img: FolderImg, imageClass: 'folder', title: 'Локальное хранение', titleClass: 'image-title'},
]


export default function Video()
{
    const { os } = useContext(FormContext);
    return (
        <section id="video"  className="main-video">
            <p className={`background-line-video ${os == 'android' ? 'android-video' : ''}`}>Видеонаблюдение</p>
            <div className="container">
                <Title props={ {type: 'section-title-big', title: 'Видеонаблюдение'} } />
                <p className="video-description">Установка и обслуживание систем видеонаблюдения, СКУД, продажа оборудования в&nbsp;Санкт&nbsp;-&nbsp;Петербурге</p>
                <ul className="video-list">
                    {cardsData.map(card => {
                        return <List props={card}/>
                    })}
                </ul>
                <ul className="video-benefits-list">
                    {benefitsData.map(benefit => {
                        return <List props={benefit}/>
                    })}
                </ul>
                <Button props={ {type: 'section-button', name: 'Оставить заявку', dataName: 'Видеонаблюдение'} } />
            </div>
        </section>
    )
}